import { VStack, Skeleton } from "@chakra-ui/react"

const ActivityCreateLoading = () => {
  return (
    <VStack gap={4} align="stretch" width="100%">
      <Skeleton height="40px" />
      <Skeleton height="60px" />
      <Skeleton height="80px" />
      <Skeleton height="60px" />
    </VStack>
  )
}

export default ActivityCreateLoading

